// Application configuration
export const config = {
  api: {
    baseURL:
      process.env.REACT_APP_API_URL ||
      "https://api.dazzling-bhaskara.167-99-73-240.plesk.page/api",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 100000,
  },

  app: {
    name: process.env.REACT_APP_NAME || "GELATO SYSTEM",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    description:
      process.env.REACT_APP_DESCRIPTION || "Financial Comparison System",
  },

  features: {
    enableMockData: process.env.REACT_APP_ENABLE_MOCK_DATA === "true",
    enableLogging: process.env.REACT_APP_ENABLE_LOGGING === "true",
    enableRefreshToken: process.env.REACT_APP_ENABLE_REFRESH_TOKEN === "true",
  },

  upload: {
    maxFileSize: parseInt(process.env.REACT_APP_MAX_FILE_SIZE) || 10485760, // 10MB
    allowedTypes: process.env.REACT_APP_ALLOWED_FILE_TYPES?.split(",") || [
      ".xls",
      ".xlsx",
      ".csv",
    ],
  },

  ui: {
    theme: process.env.REACT_APP_THEME || "modern",
    language: process.env.REACT_APP_LANGUAGE || "th",
  },
};

// API endpoints
export const endpoints = {
  auth: {
    login: "/auth/login",
    logout: "/auth/logout",
    refresh: "/auth/refresh",
    profile: "/auth/me", // Updated to match backend route
    register: "/auth/register",
  },
  users: "/users",
  masterFiles: "/master-files",
  masterData: "/master-data",
  jobs: "/jobs",
  logs: "/logs",
  permissions: "/permissions",
  roles: "/roles",
};

// Error messages
export const errorMessages = {
  network: "เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์",
  unauthorized: "ไม่มีสิทธิ์เข้าใช้งาน",
  forbidden: "ไม่อนุญาตให้ดำเนินการนี้",
  notFound: "ไม่พบข้อมูลที่ต้องการ",
  serverError: "เกิดข้อผิดพลาดในเซิร์ฟเวอร์",
  unknown: "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ",
};

// Success messages
export const successMessages = {
  loginSuccess: "เข้าสู่ระบบสำเร็จ",
  logoutSuccess: "ออกจากระบบสำเร็จ",
  saveSuccess: "บันทึกข้อมูลสำเร็จ",
  deleteSuccess: "ลบข้อมูลสำเร็จ",
  uploadSuccess: "อัปโหลดไฟล์สำเร็จ",
  exportSuccess: "ส่งออกข้อมูลสำเร็จ",
};

export default config;
